import React, { useState, useRef, useEffect } from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import { Link } from 'react-router-dom';
import Data from '../../pages/data.json'

const Sidebar = () => {
    const { darkMode, toggleDarkMode, gamesList } = useDarkMode();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const sidebarRef = useRef(null);

    // Handle mobile sidebar toggle
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Close sidebar on outside click
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                isSidebarOpen
            ) {
                setIsSidebarOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [isSidebarOpen]);

    const uniqueCategories = [...new Set(Data?.games?.map((game) => game.categories.en).flat())];
    const uniqueTag = [...new Set(Data?.games?.map((game) => game.tags.en).flat())];

    return (
        <>
            {/* Navbar */}
            <nav className="fixed top-0 z-50 w-full glass-effect border-b border-gray-200/50 dark:border-gray-700/50 backdrop-blur-md">
                <div className="px-3 py-2 lg:px-4 lg:pl-3 flex justify-between items-center">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center justify-start rtl:justify-end">
                            <button
                                onClick={toggleSidebar}
                                aria-controls="logo-sidebar"
                                type="button"
                                className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-purple-50 dark:hover:bg-purple-900/20 focus:outline-none focus:ring-2 focus:ring-purple-500 dark:text-gray-400 transition-all duration-300 hover:scale-105 active:scale-95"
                            >
                                <span className="sr-only">Open sidebar</span>
                                <svg
                                    className="w-5 h-5"
                                    aria-hidden="true"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        clipRule="evenodd"
                                        fillRule="evenodd"
                                        d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                                    />
                                </svg>
                            </button>
                            <div className='flex items-center'>
                                <a href="/" className="flex items-center group">
                                    <img
                                        src={`/logo.png`}
                                        className="w-6 h-6 sm:w-8 sm:h-8 mr-2 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-12"
                                        alt="VibeOfGames Logo"
                                    />
                                    <span className="text-base sm:text-lg lg:text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent hover:from-purple-500 hover:to-pink-500 transition-all duration-300" style={{ fontFamily: 'cursive' }}>
                                        <span className="hidden xs:inline">VibeOfGames</span>
                                        <span className="xs:hidden">VibeOfGames</span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='flex gap-1 sm:gap-2 items-center'>
                        <a target='_blank' href='https://9842.read.newszop.com/' className='hover-glow rounded-lg p-1.5 touch-manipulation'>
                            <img src='/icons/news1.png' alt="newszop" className='w-5 h-5 sm:w-6 sm:h-6 transition-transform duration-300 hover:scale-110' />
                        </a>
                        <a target='_blank' href='https://10225.play.quizzop.com/' className='hover-glow rounded-lg p-1.5 touch-manipulation'>
                            <img src='/icons/quiz2.gif' alt="quizzop" className='w-6 h-6 sm:w-7 sm:h-7 transition-transform duration-300 hover:scale-110' />
                        </a>
                    </div>
                </div>
            </nav>

            {/* Sidebar */}
            <aside
                id="logo-sidebar"
                ref={sidebarRef}
                className={`fixed top-0 left-0 z-40 w-56 h-screen pt-20 transition-transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} glass-effect border-r border-gray-200/50 sm:translate-x-0 dark:border-gray-700/50`}
                aria-label="Sidebar"
            >
                <div className="h-full px-3 pb-4 overflow-y-auto -mt-3">
                    <ul className="space-y-1 font-medium">

                        <li>
                            <Link
                                target='_blank'
                                to={`http://freshheadlines.in/`}
                                onClick={() => setIsSidebarOpen(false)}
                                className="flex items-center p-4 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gradient-to-r hover:from-purple-50 hover:to-pink-50 dark:hover:from-purple-900/20 dark:hover:to-pink-900/20 hover:text-purple-700 dark:hover:text-purple-300 transition-all duration-300 group border border-transparent hover:border-purple-200 dark:hover:border-purple-700 touch-manipulation"
                            >
                                <img src="/icons/news1.png" alt="news" className="w-7 h-7 transition-transform duration-300 group-hover:scale-110" />
                                <span className="flex-1 ml-4 font-medium text-base">News</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                target='_blank'
                                to={`https://10225.play.quizzop.com/`}
                                onClick={() => setIsSidebarOpen(false)}
                                className="flex items-center p-4 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 dark:hover:from-blue-900/20 dark:hover:to-indigo-900/20 hover:text-blue-700 dark:hover:text-blue-300 transition-all duration-300 group border border-transparent hover:border-blue-200 dark:hover:border-blue-700 touch-manipulation"
                            >
                                <img src="/icons/quiz.png" alt="quiz" className="w-7 h-7 transition-transform duration-300 group-hover:scale-110" />
                                <span className="flex-1 ml-4 font-medium text-base">Quiz</span>
                            </Link>
                        </li>

                        <li>
                            <Link
                                target='_blank'
                                to={`https://11190.play.gamezop.com/`}
                                onClick={() => setIsSidebarOpen(false)}
                                className="flex items-center p-4 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gradient-to-r hover:from-orange-50 hover:to-yellow-50 dark:hover:from-orange-900/20 dark:hover:to-yellow-900/20 hover:text-orange-700 dark:hover:text-orange-300 transition-all duration-300 group border border-transparent hover:border-orange-200 dark:hover:border-orange-700 touch-manipulation"
                            >
                                <img src="/icons/gamezop.png" alt="gamezop" className="w-7 h-7 rounded-full transition-transform duration-300 group-hover:scale-110" />
                                <span className="flex-1 ml-4 font-medium text-base">GameZop</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`/category/all-games`}
                                onClick={() => setIsSidebarOpen(false)}
                                className="flex items-center p-4 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gradient-to-r hover:from-green-50 hover:to-emerald-50 dark:hover:from-green-900/20 dark:hover:to-emerald-900/20 hover:text-green-700 dark:hover:text-green-300 transition-all duration-300 group border border-transparent hover:border-green-200 dark:hover:border-green-700 touch-manipulation"
                            >
                                <img src="/logo.png" alt="all games" className="w-7 h-7 rounded-lg transition-transform duration-300 group-hover:scale-110" />
                                <span className="flex-1 ml-4 font-medium text-base">All Games</span>
                            </Link>
                        </li>
                        {uniqueCategories?.map((item, i) => (
                            <li key={i}>
                                <Link
                                    to={`/category/${item?.toLowerCase()?.replace(/ /g, '-')}`}
                                    onClick={() => setIsSidebarOpen(false)}
                                    className="flex items-center p-4 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gradient-to-r hover:from-purple-50 hover:to-pink-50 dark:hover:from-purple-900/20 dark:hover:to-pink-900/20 hover:text-purple-700 dark:hover:text-purple-300 transition-all duration-300 group border border-transparent hover:border-purple-200 dark:hover:border-purple-700 touch-manipulation"
                                >
                                    <img src="/logo.png" alt={item} className="w-7 h-7 rounded-lg transition-transform duration-300 group-hover:scale-110" />
                                    <span className="flex-1 ml-4 font-medium text-base">{item}</span>
                                </Link>
                            </li>
                        ))}
                        {uniqueTag?.map((item, i) => (
                            <li key={i}>
                                <Link
                                    to={`/tag/${item?.toLowerCase()?.replace(/ /g, '-')}`}
                                    onClick={() => setIsSidebarOpen(false)}
                                    className="flex items-center p-4 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gradient-to-r hover:from-indigo-50 hover:to-purple-50 dark:hover:from-indigo-900/20 dark:hover:to-purple-900/20 hover:text-indigo-700 dark:hover:text-indigo-300 transition-all duration-300 group border border-transparent hover:border-indigo-200 dark:hover:border-indigo-700 touch-manipulation"
                                >
                                    <img src="/logo.png" alt={item} className="w-7 h-7 rounded-lg transition-transform duration-300 group-hover:scale-110" />
                                    <span className="flex-1 ml-4 font-medium text-base">{item}</span>
                                </Link>
                            </li>
                        ))}

                        <li>
                            <Link
                                to={`/blog`}
                                onClick={() => setIsSidebarOpen(false)}
                                className="flex items-center p-4 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gradient-to-r hover:from-pink-50 hover:to-rose-50 dark:hover:from-pink-900/20 dark:hover:to-rose-900/20 hover:text-pink-700 dark:hover:text-pink-300 transition-all duration-300 group border border-transparent hover:border-pink-200 dark:hover:border-pink-700 touch-manipulation"
                            >
                                <img src="/logo.png" alt="blogs" className="w-7 h-7 rounded-lg transition-transform duration-300 group-hover:scale-110" />
                                <span className="flex-1 ml-4 font-medium text-base">Blogs</span>
                            </Link>
                        </li>
                        
                    </ul>

                    {/* Dark Mode Toggle */}
                    <button
                        onClick={toggleDarkMode}
                        className="absolute bottom-4 left-4 p-3 bg-gradient-to-r from-purple-100 to-pink-100 dark:from-purple-900/50 dark:to-pink-900/50 text-purple-600 dark:text-purple-400 rounded-xl hover:bg-gradient-to-r hover:from-purple-200 hover:to-pink-200 dark:hover:from-purple-800/50 dark:hover:to-pink-800/50 transition-all duration-300 hover:scale-105 active:scale-95 touch-manipulation border border-purple-200 dark:border-purple-700"
                    >
                        {darkMode ? (
                            <img src='https://static.gamezop.com/comet/assets/img/theme/moon-fill.svg' className="w-5 h-5" />
                        ) : (
                            <img src='https://static.gamezop.com/comet/assets/img/theme/sun-fill.svg' className="w-5 h-5" />
                        )}
                    </button>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
